import { writable } from 'svelte/store';

export type PdfExportStatus =
  | { phase: 'idle' }
  | { phase: 'fetching'; done: number; total: number }
  | { phase: 'rendering' }
  | { phase: 'printing' }
  | { phase: 'error'; message: string };

export interface PdfExportRequest {
  volumePath: string;  // e.g. "00-authors-guide"
  volumeName: string;  // e.g. "Authors Guide"
}

export const pdfRequest = writable<PdfExportRequest | null>(null);
export const pdfStatus  = writable<PdfExportStatus>({ phase: 'idle' });

export function requestPdfExport(volumePath: string, volumeName: string) {
  pdfRequest.set({ volumePath, volumeName });
}

export function resetPdfExport() {
  pdfRequest.set(null);
  pdfStatus.set({ phase: 'idle' });
}
